import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=173d139e&scoped=true"
import script from "./AccordionCard.vue?vue&type=script&lang=js"
export * from "./AccordionCard.vue?vue&type=script&lang=js"
import style0 from "./AccordionCard.vue?vue&type=style&index=0&id=173d139e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d139e",
  null
  
)

export default component.exports